<div class="mainColumn">
  <mat-card class="theCard">

    <div class="theLogo">
			<a
				[routerLink]="['/auth/login']"
				title="Startseite"
			>
				<img
					[src]="logoSrc || 'assets/logo.png'"
					style="max-width: 100%; margin: 0 0 2em 0; mix-blend-mode: darken;"
				>
			</a>
		</div>

    <form [formGroup]="passwordForgetForm">

      <div style="margin: 2em 0;">
        <h6>
          Bitte geben Sie die E-Mail-Adresse an, die Ihrem Benutzerkonto zugeordnet ist.
        </h6>

        <div>
          <triv-input [data]="userEmailId" [fGroup]="passwordForgetForm"></triv-input>
        </div>
      </div>

      <div style="text-align: center; display: flex; flex-flow: column nowrap; align-items: center; gap: 2em">
        <button
          mat-raised-button
          color="primary"
          [disabled]="passwordForgetForm.invalid"
          style="width: 100%;"
          (click)="sendLink()"
        >
          Senden
        </button>
      </div>

    </form>

  </mat-card>
</div>
